import React from 'react';
import { useIntl } from 'react-intl';
import { localeIds } from 'locals';
import PullToRefreshFunc from 'pulltorefreshjs';

export const SetPullToRefresh: React.FC = ({ children }) => {
  const intl = useIntl();
  React.useEffect(() => {
    PullToRefreshFunc.init({
      mainElement: '#root',
      onRefresh() {
        window.location.reload();
      },
      instructionsPullToRefresh: intl.formatMessage({
        id: localeIds.pullToRefresh.pullToRefresh,
      }),
      instructionsReleaseToRefresh: intl.formatMessage({
        id: localeIds.pullToRefresh.releaseToRefresh,
      }),
      instructionsRefreshing: intl.formatMessage({
        id: localeIds.pullToRefresh.refreshing,
      }),
    });
  });

  return <>{children}</>;
};
